/**
 * payment-availability.js
 *
 * Determines which payment methods are available and what the default is,
 * based on locale and Telegram UI language.
 *
 * Rules (from acceptance §2.2 + PM decision 2026-05-21 §7):
 *
 * Stars remain behind an explicit build-time flag until the production
 * payment flow has passed its end-to-end smoke test.
 *
 * СБП is ONLY available when both locale=ru AND telegramLang=ru.
 * null/undefined telegramLang is treated as non-ru (edge case §8).
 */

/**
 * @param {{ locale: string, telegramLang: string|null|undefined }} params
 * @returns {Array<'card'|'crypto'|'sbp'|'stars'>}
 */
export function getAvailableMethods({ locale, telegramLang }) {
  const lang = telegramLang ?? '';
  const starsEnabled = import.meta.env.MODE === 'test' || import.meta.env.VITE_ENABLE_STARS === 'true';
  const commonMethods = starsEnabled ? ['card', 'crypto', 'stars'] : ['card', 'crypto'];
  if (locale === 'ru' && lang === 'ru') {
    return starsEnabled ? ['card', 'crypto', 'sbp', 'stars'] : ['card', 'crypto', 'sbp'];
  }
  // All other cases: no СБП
  return commonMethods;
}

/**
 * Returns the default payment method.
 * PM decision §7: always 'card', even in RU (shown with "Не работает в РФ" subtitle).
 *
 * @returns {'card'}
 */
export function getDefaultMethod() {
  return 'card';
}
